import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { TopNavComponent } from './top-nav/top-nav.component';

/**
 * Authenticated layout: top nav + main router outlet.
 *
 * The shell **intentionally does not** apply `max-w-*`, `mx-auto` or
 * `px-*` to `<main>`. Each route owns its own page layout — narrow
 * content wraps itself in `<g-page-container>` to get the standard
 * centered shell, while full-bleed screens (the plan layout, future
 * weekly-grid / metrics report, etc.) render edge-to-edge.
 *
 * `<main>` keeps the semantic role + `flex-1` so it absorbs the viewport
 * height below the sticky top nav; full-bleed children can then sticky-
 * position relative to the viewport without fighting an ancestor's
 * content width.
 */
@Component({
  selector: 'g-app-shell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, TopNavComponent],
  template: `
    <div class="g-screen flex flex-col">
      <g-top-nav />
      <main class="flex-1">
        <router-outlet />
      </main>
    </div>
  `,
})
export class AppShellComponent {}
